<template lang="pug">
  .navbar-bottom(ref="navbarTop")
    .navbar-wrapper
      .block
        router-link(
          class="no-blue-highlight",
          :to= 'entries[0].location'
          )
          .icon(:class="entries[0].name")
          .title
            p {{entries[0].title}}
      .block
        a.no-blue-highlight(
          :href="this.combineURL('m/Member')"
          )
          .icon(:class="entries[1].name",v-if="!isAuthenticated")
          .icon(class="member-head",v-else)
            img(:src="memberInfo.pic")
          .title
            p(v-if="!isAuthenticated") 登入
            p(v-else) {{entries[1].title}}
      .block
        a.no-blue-highlight(
          :href="this.combineURL('User/Collect.aspx')"
          )
          .icon(:class="entries[2].name")
          .title
            p {{entries[2].title}}
      .block
        router-link(
          class="no-blue-highlight",
          :to= 'entries[3].location'
          )
          .icon(:class="entries[3].name")
          .title
            p {{entries[3].title}}
</template>

<script>
import axios from 'axios';
export default {
  name: 'navbar-bottom',
  props:{
    isAuthenticated:{
      type:Boolean,
      required: false,
      default: false
    },
    memberInfo:{
      type: Object,
      required: false,
      default: function(){
        return {};
      }
    }
  },
  data(){
    return{
      activeTab: 0,
      entries:[
        {
          name: 'index',
          title: '首頁',
          location: '/'
        },
        {
          name: 'member',
          title: '個人',
          location: null,
        },
        {
          name: 'heart',
          title: '收藏',
          location: null,
        },
        {
          name: 'menu',
          title: '商品目錄',
          location: '/category'
        }
      ]
    }
  },
  computed:{
    baseURL: function(){
      // 從axios抓取根網域
      var baseURL = axios.defaults.baseURL;
      return baseURL
    }
  },
  methods:{
    combineURL(params){
      return this.baseURL+params
    }
  },
  mounted(){
    console.log(this.memberInfo)
  }
}
</script>
<style lang="scss">
  .navbar-bottom{
    .navbar-wrapper{
      .block{
        .icon{
          &.index{
            background: url('../assets/icons/tabbar_home_default.svg');
          }
          &.heart{
            background: url('../assets/icons/tabbar_heart_default.svg');
          }
          &.member{
            background: url('../assets/icons/tabbar_member_default.svg');
          }
          &.menu{
            background: url('../assets/icons/tabbar_menu_default.svg');
          }
        }
        a.router-link-exact-active{
          .icon{
            &.index{
              background: url('../assets/icons/tabbar_home_active.svg');
            }
            // &.heart{
            //   background: url('../assets/icons/tabbar_heart_active.svg');
            // }
            // &.member{
            //   background: url('../assets/icons/tabbar_member_active.svg');
            // }
            &.menu{
              background: url('../assets/icons/tabbar_menu_active.svg');
            }
          }
        }
      }
    }
  }
</style>